import { render, staticRenderFns } from "./Single.vue?vue&type=template&id=3b5da685&scoped=true"
import script from "./Single.vue?vue&type=script&lang=js"
export * from "./Single.vue?vue&type=script&lang=js"
import style0 from "./Single.vue?vue&type=style&index=0&id=3b5da685&prod&lang=css"
import style1 from "./Single.vue?vue&type=style&index=1&id=3b5da685&prod&lang=scss&scoped=true"
import style2 from "spinkit/scss/spinkit.scss?vue&type=style&index=2&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5da685",
  null
  
)

export default component.exports